import type { BuyerRequestSignatureResponse } from "api/api-marketplace";

/** Only a first invoice submission needs the separate Salesforce submit step. */
export const signAndSubmitBuyerRequest = async (
  sign: () => Promise<Pick<BuyerRequestSignatureResponse, "invoice_submission_required">>,
  submit: () => Promise<unknown>,
): Promise<void> => {
  const signature = await sign();
  // Missing flags from an older backend preserve the original first-submit flow.
  if (signature.invoice_submission_required !== false) {
    await submit();
  }
};
